import { API } from './api';
import { DefaultResponse } from './types';

interface GeolocationParams {
  lat: number;
  lon: number;
}

interface Localidade {
  cep: string;
  municipio: string;
  estado: string;
  uf: string;
  pais: string;
}

export class GeolocationService {
  public async getLocationFromCoords({
    lat,
    lon,
  }: GeolocationParams): Promise<DefaultResponse<Localidade | null>> {
    try {
      const { data } = await API.get<DefaultResponse<Localidade>>('/localidade', {
        params: {
          latitude: lat,
          longitude: lon,
        },
      });

      return data;
    } catch (error) {
      console.error('Erro ao buscar localização por coordenadas:', error);
      return {
        mensagem: 'Erro ao obter localidade.',
        sucesso: false,
        dados: null,
      };
    }
  }
}

